/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import styled from '@emotion/styled';

class DropdownButton extends React.Component {
  state = {
    open: false,
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  handleClick = event => {
    if (!this.element) return;

    if (!this.element.contains(event.target)) {
      this.setState({ open: false });
    }
  };

  toggle = () => {
    this.setState(
      ({ open }) => ({ open: !open }),
      () => {
        if (this.props.onChange) this.props.onChange(this.state.open);
      },
    );
  };

  render() {
    const { className, label, children, alignRight } = this.props;

    const classNames = [
      className,
      this.state.open ? 'expanded' : null,
      alignRight ? 'align-right' : null,
    ].filter(Boolean);

    const caretIcon = this.state.open ? 'caret-up' : 'caret-down';

    return (
      /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
      <div
        className={classNames.join(' ')}
        onClick={this.toggle}
        ref={element => {
          this.element = element;
        }}
      >
        <div className="dropdown-button">
          <span>{label}</span>
          <span>
            <FontAwesome name={caretIcon} />
          </span>
        </div>
        {this.state.open && <div className="dropdown-content">{children}</div>}
      </div>
    );
  }
}

const DropdownButtonStyled = styled(DropdownButton)`
  position: relative;

  & > .dropdown-button {
    cursor: pointer;
    display: inline-block;
    border: 1px solid #333;
    border-radius: 4px;
    padding: 1px 3px;

    & > span {
      display: inline-block;
    }

    & .fa {
      margin-left: 5px;
    }
  }

  & > .dropdown-content {
    position: absolute;
    background-color: #fff;
    border: 1px solid #333;

    padding: 4px;
  }

  &.align-right > .dropdown-content {
    left: auto;
    right: 0;
  }
`;

DropdownButton.propTypes = {
  label: PropTypes.node.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  alignRight: PropTypes.bool,
};

export default DropdownButtonStyled;
